export default "__VITE_ASSET__iXYMObZL__"